var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { Button, P, Select } from 'shared-assets/components/Elements';
import colors from 'shared-assets/lib/colors';
import CustomDatePickerRange from 'shared-assets/components/CustomDatePicker';
import { DateTime } from 'luxon';
import Icon from 'shared-assets/components/Icon';
import styled from 'styled-components';
import styles from 'shared-assets/lib/styles';
var DateSection = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 7px;\n  padding-bottom: 1em;\n  margin-bottom: 0.5em;\n"], ["\n  background: ", ";\n  border-radius: 7px;\n  padding-bottom: 1em;\n  margin-bottom: 0.5em;\n"])), colors.listView.highlightColor);
var TextContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var InputContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1em 0em 1em;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1em 0em 1em;\n"])));
var InputError = styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  &&& {\n    font-size: 0.6em;\n    margin: 1px 0 0 ", ";\n  }\n"], ["\n  color: ", ";\n  &&& {\n    font-size: 0.6em;\n    margin: 1px 0 0 ", ";\n  }\n"])), colors.fill.error, function (p) { return p.marginLeft; });
var datePickerDefaultValues = {
    startDateError: false,
    endDateError: false,
    rangeError: false,
};
var futureYears = 10;
var pastYears = 121;
var PatientCaseDate = function (_a) {
    var changeDateCallback = _a.changeDateCallback, changeDateTypeCallback = _a.changeDateTypeCallback, date = _a.date, dateTypes = _a.dateTypes, deleteDateCallback = _a.deleteDateCallback, handleErrorsCallback = _a.handleErrorsCallback, indexDate = _a.indexDate, options = _a.options, disabled = _a.disabled, dateTypeReason = _a.dateTypeReason;
    var _b = useState('default'), value = _b[0], valueSetter = _b[1];
    var _c = useState(false), allowDateRange = _c[0], allowDateRangeSetter = _c[1];
    var _d = useState(), startDate = _d[0], startDateSetter = _d[1];
    var _e = useState(), endDate = _e[0], endDateSetter = _e[1];
    var _f = useState(datePickerDefaultValues), dateValidation = _f[0], dateValidationSetter = _f[1];
    var _g = useState(false), isDateEmpty = _g[0], isDateEmptySetter = _g[1];
    useEffect(function () {
        if (dateTypes && date.patientCaseDateTypeId) {
            for (var i = 0; i < dateTypes.length; i += 1) {
                if (dateTypes[i].patientCaseDateTypeId === date.patientCaseDateTypeId) {
                    valueSetter(i.toString());
                    allowDateRangeSetter(dateTypes[i].allowDateRange);
                    break;
                }
            }
        }
    }, [dateTypes, date]);
    useEffect(function () {
        startDateSetter(date.startDate);
        endDateSetter(date.endDate);
    }, [date.startDate, date.endDate]);
    var handleValidationError = function (errorType) {
        dateValidationSetter(function (prevState) { return (__assign(__assign({}, prevState), errorType)); });
        handleErrorsCallback(indexDate, errorType);
    };
    var handleDateChange = function (val, isStartDate) {
        if (val === '' && isStartDate) {
            isDateEmptySetter(true);
        }
        else {
            isDateEmptySetter(false);
            var newDate = DateTime.fromISO(val);
            changeDateCallback(indexDate, isStartDate, newDate);
            if (isStartDate) {
                startDateSetter(newDate);
            }
            else {
                endDateSetter(newDate);
            }
        }
    };
    var handleDateTypeChange = function (e) {
        var newValue = e.target.value;
        valueSetter(newValue);
        if (dateTypes) {
            var dateType = dateTypes[parseInt(newValue)];
            if (((allowDateRange && !dateType.allowDateRange) ||
                (!allowDateRange && dateType.allowDateRange)) &&
                dateValidation.startDateError) {
                handleValidationError({ startDateError: false });
            }
            if (allowDateRange && !dateType.allowDateRange) {
                endDateSetter(undefined);
                changeDateCallback(indexDate, false, undefined);
                if (dateValidation.rangeError) {
                    handleValidationError({ rangeError: false });
                }
                if (dateValidation.endDateError) {
                    handleValidationError({ endDateError: false });
                }
            }
            allowDateRangeSetter(dateType.allowDateRange);
            changeDateTypeCallback(indexDate, dateType);
        }
    };
    var onDeleteDateClicked = function (e) {
        e.preventDefault();
        deleteDateCallback(indexDate);
    };
    var displayDateError = function (marginLeft, errorMessage) {
        return React.createElement(InputError, { marginLeft: marginLeft }, errorMessage);
    };
    // wait for the component to mount so it can display dates from database
    if (!startDate && date.startDate) {
        return null;
    }
    return (React.createElement(DateSection, null,
        React.createElement(TextContainer, null,
            React.createElement(P, { style: { color: colors.textColorPrimary, margin: '1em 0 0.5em 0' } },
                "Type of date:",
                date.dateTypeRequired && (React.createElement("span", { style: { color: colors.fill.error } }, " (required)"))),
            React.createElement(P, { style: {
                    color: colors.textColorPrimary,
                    margin: date.dateTypeRequired
                        ? '1em 0 0.5em 15.7em'
                        : '1em 0 0.5em 20em',
                } },
                allowDateRange ? 'Date Range:' : 'Date:',
                (date.isStartDateRequired || isDateEmpty) && (React.createElement("span", { style: { color: colors.fill.error } }, " (required)")))),
        React.createElement(InputContainer, null,
            React.createElement(Select, { value: value, onChange: handleDateTypeChange, disabled: disabled, style: {
                    width: '300px',
                    border: date.dateTypeRequired
                        ? "1px solid " + colors.fill.error
                        : styles.border.default,
                } }, options),
            allowDateRange ? (React.createElement(CustomDatePickerRange, { key: 1, actionButtonEnabled: false, defaultValues: { startDate: startDate, endDate: endDate }, onStartDateChange: function (val) { return handleDateChange(val, true); }, onEndDateChange: function (val) { return handleDateChange(val, false); }, showMonthAndYearSelection: true, yearLimitEnabled: true, numFutureYears: futureYears, numPastYears: pastYears, errorIfStartDateEmpty: true, onValidationError: handleValidationError })) : (React.createElement(CustomDatePickerRange, { key: 2, isSingleDate: true, actionButtonEnabled: false, defaultValues: { startDate: startDate }, onStartDateChange: function (val) { return handleDateChange(val, true); }, showMonthAndYearSelection: true, yearLimitEnabled: true, numFutureYears: futureYears, numPastYears: pastYears, errorIfStartDateEmpty: true, onValidationError: handleValidationError, style: {
                    marginRight: '150px',
                } })),
            React.createElement(Button, { type: "button", className: "link noBtn", style: { color: disabled ? colors.lightText : colors.error }, onClick: onDeleteDateClicked, disabled: disabled },
                React.createElement(Icon, { type: "trash-can-alt", fillColor: disabled ? colors.lightText : colors.error, style: { paddingRight: '10px' } }),
                "Delete")),
        disabled && (React.createElement(P, { style: {
                color: colors.lightText,
                fontSize: '9.6px',
                marginTop: '0px',
                marginBottom: '-14px',
            } },
            "This field is auto-populated, it\u2019s required for ",
            dateTypeReason,
            ".")),
        React.createElement(TextContainer, null,
            dateValidation.startDateError &&
                !isDateEmpty &&
                displayDateError('30rem', 'Insert a valid date format'),
            dateValidation.endDateError &&
                dateValidation.startDateError &&
                displayDateError('3.2rem', 'Insert a valid date format'),
            dateValidation.endDateError &&
                !dateValidation.startDateError &&
                displayDateError('39.5rem', 'Insert a valid date format'),
            !dateValidation.startDateError &&
                !dateValidation.endDateError &&
                dateValidation.rangeError &&
                displayDateError('39.5rem', "End date can't occur before start date"))));
};
export default PatientCaseDate;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
